export const SenderTypesConst = {
  Business: 'business',
  Personal: 'personal'
};
export const SenderTypes = [SenderTypesConst.Business, SenderTypesConst.Personal] as const;
export type SenderTypeOptions = (typeof SenderTypes)[number];
